import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";

export class AvtalCommandBase extends BasicCommand<AvtalCommandBase> {

    avtalGuid: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Avtal";

    get primaryKey(): IAvtalPrimaryKey {
        return {
            avtalGuid: this.avtalGuid
        };
    }

    constructor(avtalGuid: string, type: string, commandType: CommandType) {
        super(type, AvtalCommandBase.$groupKey, commandType);
        this.avtalGuid = avtalGuid;
    }
}

export interface IAvtalPrimaryKey extends IPrimaryKey<IAvtalPrimaryKey>{
    avtalGuid: string;
}
